import { DefaultSeoProps } from 'next-seo';

const config: DefaultSeoProps = {
  dangerouslySetAllPagesToNoFollow: true,
  dangerouslySetAllPagesToNoIndex: true,
  title: "Lovevery | Learning Through Play for Your Child's Developing Brain",
  description:
    'Award-winning, Montessori-inspired toys and subscription boxes for babies and toddlers. Designed by child development experts and sustainably-made.',
  openGraph: {
    type: 'website',
    siteName: 'Lovevery',
    title: "Lovevery | Learning Through Play for Your Child's Developing Brain",
    description:
      'Award-winning, Montessori-inspired toys and subscription boxes for babies and toddlers. Designed by child development experts and sustainably-made.',
    url: 'https://lovevery.com/',
  },
};

export default config;
